<template>
  <nav class="pagination is-small" role="navigation" aria-label="pagination">
    <a v-if="pageList.length > 0" class="pagination-previous" @click="setPage(current_page-1)">Previous</a>
    <a v-if="pageList.length > 0" class="pagination-next" @click="setPage(current_page+1)">Next page</a>
    <div class="pagination-page-length">
      Per Page:
      <select name="paginator-page-length" @change="setPageLength(parseInt($event.target.value))">
        <option v-for="length in pageLengthOptions"
                :selected="page_length === length"
                :value="length">{{ length }}
        </option>
      </select>
    </div>
    <ul class="pagination-list">
      <li v-for="page in pageList">
        <a v-if="page.type === 'page'"
           :class="{
             'pagination-link': true,
             'is-current': page.isCurrent
           }"
           :aria-label="'Goto page ' + page.number"
           @click="setPage(page.number)">
          {{ page.number }}
        </a>
        <span v-else :class="{'pagination-ellipsis': true}">&hellip;</span>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss">
.pagination-page-length {
  display: inline-flex;
  align-items: center;
  line-height: 1.5;
  justify-content: center;
  position: relative;
  vertical-align: top;
  order: 4;
  margin-left: 0.5em;

  select {
    margin-left: 0.5em;
    height: 2.25em;
    border: 1px solid transparent;
    border-radius: 4px;
  }
}
</style>

<script>
export default {
  name: 'paginator',
  props: {
    current_page: Number,
    page_length: Number,
    data_length: Number,
  },
  data() {
    return {
      pageLengthOptions: [10, 25, 50, 100, 250, 500],
    }
  },
  methods: {
    setPage(page) {
      this.$emit('set-page', Math.max(Math.min(this.total_pages, page), 1));
    },
    setPageLength(length) {
      this.$emit('set-page-length', length);
    },
  },
  computed: {
    total_pages() {
      return Math.ceil(this.data_length / this.page_length);
    },
    pageList() {
      let pageCount   = this.total_pages;
      let firstPage   = 1
      let currentPage = this.current_page
      let pageDelta   = pageCount - firstPage
      let pages       = []
      // add the first page to the list
      pages.push({ isCurrent: firstPage === currentPage, number: firstPage, type: 'page' })
      if (pageDelta > 5) {
        pages.push({ type: 'ellipsis' })
        let navPages   = Math.min(pageDelta, 5)
        let rangeStart = currentPage > Math.floor(firstPage + navPages / 2)
          ? Math.min(currentPage - Math.floor(navPages / 2), pageCount - navPages)
          : 2;
        let rangeEnd   = currentPage > Math.floor(firstPage + navPages / 2)
          ? Math.min(currentPage + Math.floor(navPages / 2), pageCount - 1)
          : 1 + navPages;
        for (let x = rangeStart; x <= rangeEnd; x++) {
          pages.push({ isCurrent: x === currentPage, number: x, type: 'page' })
        }
        pages.push({ type: 'ellipsis' })
      }
      else if (pageDelta > 1) {
        for (let x = 2; x <= pageDelta; x++) {
          pages.push({ isCurrent: x === currentPage, number: x, type: 'page' })
        }
      }
      // add the last page to the list
      pages.push({ isCurrent: pageCount === currentPage, number: pageCount, type: 'page' })

      return pageDelta > 0 ? pages : []
    },
  },
}
</script>



// WEBPACK FOOTER //
// Paginator.vue?42d44969